import { yupResolver } from '@hookform/resolvers/yup';
import { Stack, Dialog, Button, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import { useEffect, useCallback } from 'react';
import { useForm } from 'react-hook-form';
import FormProvider, { RHFTextField } from 'src/components/hook-form';
import { BankOptions } from 'src/hooks/use-bank-option';
import { BranchType } from 'src/type/branch';

import axios, { endpoints } from 'src/utils/axios';
import { toastError } from 'src/utils/format-error';
import * as Yup from 'yup';

type Props = {
  open: boolean;
  onClose: () => void;
  branch: BranchType | null;
  forceReload: () => void;
  bankOptions: BankOptions[];
};

const defaultValues = {
  name: '',
};

const Schema = Yup.object().shape({
  name: Yup.string().required('จำเป็นต้องชื่อสาขา'),
});

export default function SettingBranchFormDialog({
  open,
  onClose,
  branch,
  forceReload,
  bankOptions,
}: Props) {
  const methods = useForm({
    mode: 'onChange',
    resolver: yupResolver(Schema),
    defaultValues,
  });

  const {
    handleSubmit,
    reset,
    formState: { isSubmitting },
  } = methods;

  useEffect(() => {
    if (open) {
      if (branch) {
        reset({
          name: branch.name,
        });
      } else {
        reset(defaultValues);
      }
    }
  }, [branch, open]);

  const onSubmit = handleSubmit(async (values) => {
    try {
      let data: BranchType;

      const body = {
        name: values.name,
      };

      if (branch) {
        const response = await axios.patch<BranchType>(endpoints.branch.update(branch.id), body);
        ({ data } = response);
      } else {
        const response = await axios.post<BranchType>(endpoints.branch.create, body);
        ({ data } = response);
      }

      if (!data) {
        throw new Error('ไม่สามารถบันทึกข้อมูลได้');
      }

      enqueueSnackbar('อัพเดทข้อมูลสำเร็จ', { variant: 'success' });
      forceReload();
      beforeClose();
    } catch (error) {
      toastError(error);
    }
  });

  const beforeClose = useCallback(() => {
    onClose();
    reset(defaultValues);
  }, []);

  const actionText = branch ? 'แก้ไข' : 'เพิ่ม';

  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={beforeClose}>
      <FormProvider methods={methods} onSubmit={onSubmit}>
        <DialogTitle sx={{ pb: 2 }}>{actionText}สาขา</DialogTitle>
        <DialogContent>
          <Stack spacing={3} sx={{ pt: 3 }}>
            <RHFTextField name="name" label="ชื่อสาขา" placeholder="ชื่อสาขา" />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" color="inherit" onClick={beforeClose}>
            ยกเลิก
          </Button>
          <Button variant="contained" disabled={isSubmitting} type="submit">
            บันทึก
          </Button>
        </DialogActions>
      </FormProvider>
    </Dialog>
  );
}
